

import React, { useState, useEffect } from 'react';
import { ShoppingCart, DeleteOutline } from '@mui/icons-material';
import CartItemsList from './CartItemsList';
import PriceSummary from './PriceSummary';
import PaymentOptions from './PaymentOptions';

const CartSidebar = ({
  cartItems,
  quantities,
  cartItemsCount,
  onClearCart,
  onDecrementQuantity,
  onIncrementQuantity,
  subTotal,
  gstTotal,
  platformCharges,
  packingCharges,
  deliveryCharges,
  discountAmount,
  grandTotal,
  appliedCoupon,
  onRemoveCoupon,
  onApplyCoupon,
  orderType,
  setOrderType,
  selectedAddressObj,
  onShowAddressPopup,
  showPaymentOptions,
  setShowPaymentOptions,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  selectedwalletTypes,
  setSelectedwalletTypes,
  onPlaceOrder,
  orderPlacing,
  onOpenScheduleModal,
  availableBalance,
  availableSelf,
  availableCompany,
  availableCashback,
  onShowGST,
  fetchCartData,

  updateAddonQuantity,
  cartData: propCartData
}) => {
  const userId = localStorage.getItem("userId");
  const authToken = localStorage.getItem("authToken");
  const [cartId, setCartId] = useState(propCartData?.cartId || localStorage.getItem("cartId"));

  useEffect(() => {
    if (propCartData?.cartId) {
      setCartId(propCartData.cartId);
    }
  }, [propCartData]);

  return (
    <div style={{
      width: '352px',
      backgroundColor: '#fafafa',
      borderRadius: '16px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
      position: 'sticky',
      top: '90px',
      height: 'calc(100vh - 110px)',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    }}>
      {/* Header */}
      <div style={{
        padding: '16px 20px',
        backgroundColor: '#ee6521',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <ShoppingCart style={{ fontSize: '22px' }} />
          <span style={{ fontWeight: 'bold', fontSize: '16px' }}>Your Cart</span>
          <span style={{ background: 'rgba(255,255,255,0.25)', padding: '2px 10px', borderRadius: '20px', fontSize: '12px' }}>
            {cartItemsCount} items
          </span>
        </div>
        {cartItems.length > 0 && (
          <button onClick={onClearCart} style={{
            background: 'rgba(255,255,255,0.2)',
            border: 'none',
            color: '#fff',
            cursor: 'pointer',
            padding: '6px 12px',
            borderRadius: '20px',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
            gap: '5px'
          }}>
            <DeleteOutline style={{ fontSize: '16px' }} /> Clear
          </button>
        )}
      </div>

      {/* Scrollable Content */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '16px',scrollbarWidth: 'none' }}>
        {cartItems.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px 20px', color: '#bbb' }}>
            <ShoppingCart style={{ fontSize: '64px', marginBottom: '16px', opacity: 0.4 }} />
            <p style={{ margin: 0, fontWeight: '500' }}>Your cart is empty</p>
            <p style={{ margin: '8px 0 0', fontSize: '13px' }}>Add items from the menu</p>
          </div>
        ) : (
          <>
           <CartItemsList
    cartItems={cartItems}
    quantities={quantities}
    onDecrement={onDecrementQuantity}
    onIncrement={onIncrementQuantity}
    onUpdateAddon={updateAddonQuantity}
/>
            
            
            <PriceSummary
  subTotal={subTotal}
  gstTotal={gstTotal}
  platformCharges={platformCharges}
  packingCharges={packingCharges}
  deliveryCharges={deliveryCharges}
  discountAmount={discountAmount}
  grandTotal={grandTotal}
  appliedCoupon={appliedCoupon}
  onRemoveCoupon={onRemoveCoupon}
  onApplyCoupon={onApplyCoupon}
  onShowGST={onShowGST}
  fetchCartData={fetchCartData}  // ✅ Pass this
  cartId={cartId}  // ✅ Pass cartId
  userId={userId}  // ✅ Pass userId
  token={authToken}  // ✅ Pass token
/>
            
            <PaymentOptions
              orderType={orderType}
              setOrderType={setOrderType}
              selectedAddressObj={selectedAddressObj}
              onShowAddressPopup={onShowAddressPopup}
              showPaymentOptions={showPaymentOptions}
              setShowPaymentOptions={setShowPaymentOptions}
              selectedPaymentMethod={selectedPaymentMethod}
              setSelectedPaymentMethod={setSelectedPaymentMethod}
              selectedwalletTypes={selectedwalletTypes}
              setSelectedwalletTypes={setSelectedwalletTypes}
              onPlaceOrder={onPlaceOrder}
              orderPlacing={orderPlacing}
              onOpenScheduleModal={onOpenScheduleModal}
              availableBalance={availableBalance}
              availableSelf={availableSelf}
              availableCompany={availableCompany}
              availableCashback={availableCashback}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default CartSidebar;